/**
 * Created by lu on 2018/4/10.
 */
var nb = require('../../../../nb');
module.exports = nb.define({
    view: {
        'class': 'section section-wineType',
        $html: {
            'class': 'container',
            $html: [{
                'class': 'section-title',
                $html: [{
                    'class': 'title-cn',
                    $text: nb.bind('title')
                }, {
                    'class': 'title-en',
                    $text: nb.bind('titleEn')
                }]
            }, {
                'class': 'type-list',
                $html: {
                    'class': 'clearfix',
                    $type: nb.view.List,
                    $model: ''
                }
            }]
        }
    },
    method: {
        init: function () {
            nb.model.onChange(nb.opts.clientReady, function () {
                $(".type-item").hover3d({
                    selector: ".item-content",
                    shine: true,
                    sensitivity: 20
                });
            });
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/view/wineType/TypeList.js
// module id = 511
// module chunks = 6